export { default } from './empty-state.component';
